import { render, staticRenderFns } from "./priceIndex.vue?vue&type=template&id=14de3dd9&scoped=true"
import script from "./priceIndex.vue?vue&type=script&lang=js"
export * from "./priceIndex.vue?vue&type=script&lang=js"
import style0 from "./priceIndex.vue?vue&type=style&index=0&id=14de3dd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14de3dd9",
  null
  
)

export default component.exports